  import styles from './CadastroAdmin.module.css';
  import HeaderGestaoAdmin from '../components/HeaderGestaoAdmin';
  import SideBarGestaoAdmin from '../components/SideBarGestaoAdmin';
  import { useState } from 'react';
  import { useNavigate } from 'react-router-dom';
  import Input from "../../../shared/form/Input";
  function CadastroAdmin() {
    const [email, setEmail] = useState('');
    const [nome, setNome] = useState('');
    const [telefone, setTelefone] = useState('');
    const [senha, setSenha] = useState('');
    const [confirmSenha, setConfirmSenha] = useState('');
    const [codigo, setCodigo] = useState('');
    const [step, setStep] = useState(1); // 1: cadastro, 2: verificar código
    const [error, setError] = useState('');
    const [senhaForte, setSenhaForte] = useState({ valida: false, mensagem: '' });
    const tipo_estabelecimento = localStorage.getItem("tipo_estabelecimento")
    const navigate = useNavigate();

    // Validar força da senha em tempo real
    const validarSenha = (senha) => {
      if (senha.length < 8) {
        return { valida: false, mensagem: 'A senha deve ter no mínimo 8 caracteres' };
      }
      if (!/[A-Z]/.test(senha)) {
        return { valida: false, mensagem: 'A senha deve conter pelo menos uma letra maiúscula' };
      }
      if (!/[a-z]/.test(senha)) {
        return { valida: false, mensagem: 'A senha deve conter pelo menos uma letra minúscula' };
      }
      if (!/[0-9]/.test(senha)) {
        return { valida: false, mensagem: 'A senha deve conter pelo menos um número' };
      }
      return { valida: true, mensagem: 'Senha forte!' };
    };

    const handleSenhaChange = (e) => {
      const novaSenha = e.target.value;
      setSenha(novaSenha);
      setSenhaForte(validarSenha(novaSenha));
    };

    // 1️⃣ Envia código por e-mail
    const enviarCodigo = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL;

        const response = await fetch(`${API_URL}/enviar-codigo`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, nome, senha, telefone })
        });

        const data = await response.json();

        if (response.ok) {
          setStep(2); // muda para a tela de inserir código
        } else {
          setError(data.error || "Erro ao enviar código.");
        }
      } catch (err) {
        console.error(err);
        setError("Erro ao enviar código. Tente novamente.");
      }
    };

    // 2️⃣ Confirma código e finaliza cadastro
    const confirmarCodigo = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL;

        console.log("📤 Enviando para verificar código:", { email, codigo });

        const response = await fetch(`${API_URL}/verificar-codigo`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, nome, telefone, senha, codigo }) // ✅ envia todos os campos
        });


        const data = await response.json();

        console.log("📥 Resposta completa do backend:", data);
        console.log("📥 Status da resposta:", response.status);

        if (response.ok) {
          console.log("✅ Resposta do backend:", data);
          console.log("✅ Admin ID recebido do backend:", data.admin_id);

          if (data.admin_id) {
            // Limpar localStorage anterior antes de salvar novo admin_id
            console.log("🗑️ Admin ID anterior no localStorage:", localStorage.getItem("admin_id"));
            // Novo admin/estabelecimento: remove resíduos de uma sessão anterior (ex: universidade
            // de outro cadastro/teste), senão o EstabelecimentosContext filtra pelo id errado.
            localStorage.removeItem("id_universidade");
            localStorage.removeItem("nomeUniversidade");
            localStorage.removeItem("estabelecimento_id");
            localStorage.removeItem("id_cliente");
            localStorage.setItem("admin_id", data.admin_id);
            if (data.token) {
              localStorage.setItem("token", data.token);
            }
            console.log("✅ Admin ID NOVO salvo no localStorage:", localStorage.getItem("admin_id"));
            console.log("✅ Tipo do admin_id:", typeof data.admin_id);
            alert("Conta Criada com sucesso!");
            navigate("/cadastroestabelecimento");
          } else {
            console.error("❌ admin_id não foi retornado pelo backend");
            setError("Erro: ID do administrador não foi retornado.");
          }
        } else {
          console.error("❌ Erro na resposta:", data);
          setError(data.error || "Código inválido.");
        }
      } catch (err) {
        console.error("❌ Erro na requisição:", err);
        setError("Erro ao verificar código. Tente novamente.");
      }
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      setError('');

      // Validar força da senha
      if (!senhaForte.valida) {
        setError(senhaForte.mensagem);
        return;
      }

      if (senha !== confirmSenha) {
        setError("As senhas não coincidem.");
        return;
      }

      enviarCodigo();
    };

    return (
      <main className={styles.secaoprincipal}>

        <header className={styles.cabecalho_pageAdmin}>
      <h2>
        Bem-vindo ao {tipo_estabelecimento === 'eatorder' ? 'EatOrder' : 'UniEat'}!
      </h2>


          {step === 1 && (
            <p>Crie sua conta gratuitamente e comece a vender mais, gerenciando os pedidos do seu estabelecimento de forma simples.</p>
          )}
        </header>

        {step === 1 && (
          <form onSubmit={handleSubmit} className={styles.formulario}>
            <Input
              type="text"
              text="Nome do Admin"
              name="nomeadmin"
              placeholder= "Digite seu nome completo"
              handleOnChange={(e) => setNome(e.target.value)}
              value={nome}
            />
               <Input
              type="text"
              text="Telefone do Admin"
              name="telefoneadmin"
              placeholder="(11) 12345-6789"
              handleOnChange={(e) => setTelefone(e.target.value)}
              value={telefone}
            />
             <Input
              type="email"
              text="Digite seu email: "
              name="emailadmin"
              placeholder="Email do Administrador"
              handleOnChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            <Input
              type="password"
              text="Senha"
              name="senhaadmin"
              placeholder="Mínimo 8 caracteres, letras e números"
              handleOnChange={handleSenhaChange}
              value={senha}
            />
            {senha && (
              <p style={{
                fontSize: '0.85rem',
                color: senhaForte.valida ? 'green' : 'orange',
                marginTop: '-10px',
                marginBottom: '10px'
              }}>
                {senhaForte.mensagem}
              </p>
            )}
            <Input
              type="password"
              text="Confirme a Senha"
              name="confirmsenhaadmin"
              placeholder="Confirme a senha"
              handleOnChange={(e) => setConfirmSenha(e.target.value)}
              value={confirmSenha}
            />
            {error && <p className={styles.error}>{error}</p>}
            <button className={styles.btnCadastrar} type="submit">Criar minha conta</button>
            <p className={styles.termos}>
              Ao criar sua conta, você concorda com nossos termos de uso e política de privacidade.
            </p>
          </form>
        )}

        {step === 2 && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              confirmarCodigo();
            }}
            className={styles.formularioVerificacaoCode}
          >
            <p>Um código de verificação foi enviado para {email}. <br/> Digite-o abaixo:</p>
            <Input
              type="text"
              text="Código de verificação"
              name="codigo"
              placeholder="123456"
              handleOnChange={(e) => setCodigo(e.target.value)}
            />
            {error && <p className={styles.error}>{error}</p>}
            <button className={styles.btn} type="submit">Confirmar Código</button>
          </form>
        )}
      </main>
    );
  }

  export default CadastroAdmin;
